module.exports = __webpack_public_path__ + "img/activityBigCover.3e35c831.png";